import React, { FC, useCallback } from "react";
import { useSelector } from "react-redux";
import { Color } from "@evergis/color";
import { useTranslation } from "react-i18next";

import { ToggleBlock } from "../../../components/ToggleBlock/ToggleBlock";
import { ColorMargin, GridSettingContainer } from "../styled";
import { useAction } from "../../../hooks/useAction";
import { getPrintWithGrid, GRID_DEFAULTS } from "../../../ducks/print/selectors";
import { setGrid } from "../../../ducks/print/print";
import { GridSizeSetting } from "./GridSizeSetting";
import { GridColorSetting } from "./GridColorSetting";
import { BaseMapTheme } from "../../MapControls/components/BasemapSelect/BasemapBlock";
import { useBaseMapProperties } from "../../../hooks/project/useBaseMap";

export const GridSetting: FC = () => {
  const { t } = useTranslation("print");
  const updateGrid = useAction(setGrid);
  const { theme: baseMapTheme } = useBaseMapProperties();
  const gridEnabled = useSelector(getPrintWithGrid);

  const toggleEnableGrid = useCallback(
    () => updateGrid(gridEnabled ? null : getGridSettings(baseMapTheme)),
    [updateGrid, gridEnabled, baseMapTheme],
  );

  return (
    <ToggleBlock label={t("graticule")} checked={gridEnabled} onChange={toggleEnableGrid}>
      <GridSettingContainer>
        <GridSizeSetting />
        <ColorMargin>
          <GridColorSetting />
        </ColorMargin>
      </GridSettingContainer>
    </ToggleBlock>
  );
};

function getGridSettings(baseMapTheme: BaseMapTheme) {
  return {
    ...GRID_DEFAULTS,
    color: baseMapTheme === BaseMapTheme.Light ? new Color("#000") : new Color("#fff"),
  };
}
